var map = {
	"./atlanta/cost-per-lead.json": 56302,
	"./houston/cost-per-lead.json": 20969,
	"./new-york/cost-per-lead.json": 65475,
	"./san-francisco/cost-per-lead.json": 90154,
	"./seattle/cost-per-lead.json": 41077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70125;